// import React, { useState, useEffect } from "react";

// const AlumniEditForm = ({ alumni, onClose, onUpdate }) => {
//   const [formData, setFormData] = useState({
//     reg_no: "",
//     name: "",
//     permanent_address: "",
//     correspondence_address: "",
//     mobile_no: "",
//     resident_no: "",
//     personal_email: "",
//     office_email: "",
//     nic_passport_no: "",
//     designation: "",
//     official_address: "",
//     sab_academic_qualifications: "",
//     year_of_enrollment: "",
//     sab_reg_no: "",
//     intake: "",
//     year_of_degree_obtained: "",
//     approval_status: "",
//   });

//   useEffect(() => {
//     if (alumni) {
//       setFormData({
//         reg_no: alumni.reg_no || "",
//         name: alumni.name || "",
//         permanent_address: alumni.permanent_address || "",
//         correspondence_address: alumni.correspondence_address || "",
//         mobile_no: alumni.mobile_no || "",
//         resident_no: alumni.resident_no || "",
//         personal_email: alumni.personal_email || "",
//         office_email: alumni.office_email || "",
//         nic_passport_no: alumni.nic_passport_no || "",
//         designation: alumni.designation || "",
//         official_address: alumni.official_address || "",
//         sab_academic_qualifications: alumni.sab_academic_qualifications || "",
//         year_of_enrollment: alumni.year_of_enrollment || "",
//         sab_reg_no: alumni.sab_reg_no || "",
//         intake: alumni.intake || "",
//         year_of_degree_obtained: alumni.year_of_degree_obtained || "",
//         approval_status: alumni.approval_status || "",
//       });
//     }
//   }, [alumni]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const {
//       permanent_address,
//       correspondence_address,
//       mobile_no,
//       resident_no,
//       personal_email,
//       office_email,
//       designation,
//       official_address
//     } = formData;

//     onUpdate({
//       permanent_address,
//       correspondence_address,
//       mobile_no,
//       resident_no,
//       personal_email,
//       office_email,
//       designation,
//       official_address
//     });
//     onClose();
//   };

//   if (!alumni) {
//     return null;
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="w-4/5 max-w-4xl bg-white rounded-lg shadow-md"> {/* Increased width, max-width */}
//         <h2 className="p-4 text-2xl font-semibold">Edit Alumni Details</h2>
//         <form onSubmit={handleSubmit} className="p-4">
//           <div className="grid grid-cols-1 gap-4 overflow-y-auto md:grid-cols-2 max-h-96"> {/* Two columns on medium screens and up, scrollable */}

//             {/* Read-Only Fields */}
//             <div>
//               <label htmlFor="reg_no" className="block mb-2 text-sm font-bold text-gray-700">RID:</label>
//               <input
//                 type="text"
//                 id="reg_no"
//                 name="reg_no"
//                 value={formData.reg_no}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="name" className="block mb-2 text-sm font-bold text-gray-700">Name:</label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 value={formData.name}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="nic_passport_no" className="block mb-2 text-sm font-bold text-gray-700">NIC/Passport Number:</label>
//               <input
//                 type="text"
//                 id="nic_passport_no"
//                 name="nic_passport_no"
//                 value={formData.nic_passport_no}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="sab_academic_qualifications" className="block mb-2 text-sm font-bold text-gray-700">BSc. (Applied Accounting):</label>
//               <input
//                 type="text"
//                 id="sab_academic_qualifications"
//                 name="sab_academic_qualifications"
//                 value={formData.sab_academic_qualifications}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="year_of_enrollment" className="block mb-2 text-sm font-bold text-gray-700">Year of Enrollment:</label>
//               <input
//                 type="text"
//                 id="year_of_enrollment"
//                 name="year_of_enrollment"
//                 value={formData.year_of_enrollment}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="sab_reg_no" className="block mb-2 text-sm font-bold text-gray-700">SAB Registration Number:</label>
//               <input
//                 type="text"
//                 id="sab_reg_no"
//                 name="sab_reg_no"
//                 value={formData.sab_reg_no}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="intake" className="block mb-2 text-sm font-bold text-gray-700">Intake:</label>
//               <input
//                 type="text"
//                 id="intake"
//                 name="intake"
//                 value={formData.intake}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="year_of_degree_obtained" className="block mb-2 text-sm font-bold text-gray-700">Year of Obtaining Degree:</label>
//               <input
//                 type="text"
//                 id="year_of_degree_obtained"
//                 name="year_of_degree_obtained"
//                 value={formData.year_of_degree_obtained}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="approval_status" className="block mb-2 text-sm font-bold text-gray-700">Approval Status:</label>
//               <input
//                 type="text"
//                 id="approval_status"
//                 name="approval_status"
//                 value={formData.approval_status}
//                 disabled
//                 className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>

//             {/* Editable Fields */}
//             <div>
//               <label htmlFor="permanent_address" className="block mb-2 text-sm font-bold text-gray-700">Permanent Address:</label>
//               <input
//                 type="text"
//                 id="permanent_address"
//                 name="permanent_address"
//                 value={formData.permanent_address}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="correspondence_address" className="block mb-2 text-sm font-bold text-gray-700">Correspondence Address:</label>
//               <input
//                 type="text"
//                 id="correspondence_address"
//                 name="correspondence_address"
//                 value={formData.correspondence_address}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="mobile_no" className="block mb-2 text-sm font-bold text-gray-700">Mobile Number:</label>
//               <input
//                 type="text"
//                 id="mobile_no"
//                 name="mobile_no"
//                 value={formData.mobile_no}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="resident_no" className="block mb-2 text-sm font-bold text-gray-700">Resident Number:</label>
//               <input
//                 type="text"
//                 id="resident_no"
//                 name="resident_no"
//                 value={formData.resident_no}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="personal_email" className="block mb-2 text-sm font-bold text-gray-700">Personal Email:</label>
//               <input
//                 type="email"
//                 id="personal_email"
//                 name="personal_email"
//                 value={formData.personal_email}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="office_email" className="block mb-2 text-sm font-bold text-gray-700">Office Email:</label>
//               <input
//                 type="email"
//                 id="office_email"
//                 name="office_email"
//                 value={formData.office_email}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="designation" className="block mb-2 text-sm font-bold text-gray-700">Designation:</label>
//               <input
//                 type="text"
//                 id="designation"
//                 name="designation"
//                 value={formData.designation}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//             <div>
//               <label htmlFor="official_address" className="block mb-2 text-sm font-bold text-gray-700">Company Name:</label>
//               <input
//                 type="text"
//                 id="official_address"
//                 name="official_address"
//                 value={formData.official_address}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
//               />
//             </div>
//           </div>

//           <div className="flex justify-end p-4 space-x-8">
//             <button
//               type="button"
//               className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//               onClick={onClose}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
//             >
//               Update
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AlumniEditForm;

import React, { useState, useEffect } from "react";

const AlumniEditForm = ({ alumni, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    reg_no: "",
    name: "",
    permanent_address: "",
    correspondence_address: "",
    mobile_no: "",
    resident_no: "",
    personal_email: "",
    office_email: "",
    nic_passport_no: "",
    designation: "",
    official_address: "",
    sab_academic_qualifications: "",
    year_of_enrollment: "",
    sab_reg_no: "",
    intake: "",
    year_of_degree_obtained: "",
    approval_status: "",
  });

  useEffect(() => {
    if (alumni) {
      setFormData({
        reg_no: alumni.reg_no || "",
        name: alumni.name || "",
        permanent_address: alumni.permanent_address || "",
        correspondence_address: alumni.correspondence_address || "",
        mobile_no: alumni.mobile_no || "",
        resident_no: alumni.resident_no || "",
        personal_email: alumni.personal_email || "",
        office_email: alumni.office_email || "",
        nic_passport_no: alumni.nic_passport_no || "",
        designation: alumni.designation || "",
        official_address: alumni.official_address || "",
        sab_academic_qualifications: alumni.sab_academic_qualifications || "",
        year_of_enrollment: alumni.year_of_enrollment || "",
        sab_reg_no: alumni.sab_reg_no || "",
        intake: alumni.intake || "",
        year_of_degree_obtained: alumni.year_of_degree_obtained || "",
        approval_status: alumni.approval_status || "",
      });
    }
  }, [alumni]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Extract *all* fields from formData
    const {
      permanent_address,
      correspondence_address,
      mobile_no,
      resident_no,
      personal_email,
      office_email,
      designation,
      official_address,
      reg_no,
      name,
      nic_passport_no,
      sab_academic_qualifications,
      year_of_enrollment,
      sab_reg_no,
      intake,
      year_of_degree_obtained,
      approval_status
    } = formData;

    // Create an object with ALL fields
    const allData = {
      permanent_address,
      correspondence_address,
      mobile_no,
      resident_no,
      personal_email,
      office_email,
      designation,
      official_address,
      reg_no,
      name,
      nic_passport_no,
      sab_academic_qualifications,
      year_of_enrollment,
      sab_reg_no,
      intake,
      year_of_degree_obtained,
      approval_status
    };

    onUpdate(allData);  // Pass the complete object
    onClose();
  };

  if (!alumni) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-4/5 max-w-4xl bg-white rounded-lg shadow-md"> {/* Increased width, max-width */}
        <h2 className="p-4 text-2xl font-semibold">Edit Alumni Details</h2>
        <form onSubmit={handleSubmit} className="p-4">
          <div className="grid grid-cols-1 gap-4 overflow-y-auto md:grid-cols-2 max-h-96"> {/* Two columns on medium screens and up, scrollable */}

            {/* Read-Only Fields */}
            <div>
              <label htmlFor="reg_no" className="block mb-2 text-sm font-bold text-gray-700">RID:</label>
              <input
                type="text"
                id="reg_no"
                name="reg_no"
                value={formData.reg_no}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="name" className="block mb-2 text-sm font-bold text-gray-700">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="nic_passport_no" className="block mb-2 text-sm font-bold text-gray-700">NIC/Passport Number:</label>
              <input
                type="text"
                id="nic_passport_no"
                name="nic_passport_no"
                value={formData.nic_passport_no}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="sab_academic_qualifications" className="block mb-2 text-sm font-bold text-gray-700">BSc. (Applied Accounting):</label>
              <input
                type="text"
                id="sab_academic_qualifications"
                name="sab_academic_qualifications"
                value={formData.sab_academic_qualifications}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="year_of_enrollment" className="block mb-2 text-sm font-bold text-gray-700">Year of Enrollment:</label>
              <input
                type="text"
                id="year_of_enrollment"
                name="year_of_enrollment"
                value={formData.year_of_enrollment}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="sab_reg_no" className="block mb-2 text-sm font-bold text-gray-700">SAB Registration Number:</label>
              <input
                type="text"
                id="sab_reg_no"
                name="sab_reg_no"
                value={formData.sab_reg_no}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="intake" className="block mb-2 text-sm font-bold text-gray-700">Intake:</label>
              <input
                type="text"
                id="intake"
                name="intake"
                value={formData.intake}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="year_of_degree_obtained" className="block mb-2 text-sm font-bold text-gray-700">Year of Obtaining Degree:</label>
              <input
                type="text"
                id="year_of_degree_obtained"
                name="year_of_degree_obtained"
                value={formData.year_of_degree_obtained}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="approval_status" className="block mb-2 text-sm font-bold text-gray-700">Approval Status:</label>
              <input
                type="text"
                id="approval_status"
                name="approval_status"
                value={formData.approval_status}
                disabled
                className="w-full px-3 py-2 leading-tight text-gray-700 bg-gray-100 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>

            {/* Editable Fields */}
            <div>
              <label htmlFor="permanent_address" className="block mb-2 text-sm font-bold text-gray-700">Permanent Address:</label>
              <input
                type="text"
                id="permanent_address"
                name="permanent_address"
                value={formData.permanent_address}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="correspondence_address" className="block mb-2 text-sm font-bold text-gray-700">Correspondence Address:</label>
              <input
                type="text"
                id="correspondence_address"
                name="correspondence_address"
                value={formData.correspondence_address}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="mobile_no" className="block mb-2 text-sm font-bold text-gray-700">Mobile Number:</label>
              <input
                type="text"
                id="mobile_no"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="resident_no" className="block mb-2 text-sm font-bold text-gray-700">Resident Number:</label>
              <input
                type="text"
                id="resident_no"
                name="resident_no"
                value={formData.resident_no}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="personal_email" className="block mb-2 text-sm font-bold text-gray-700">Personal Email:</label>
              <input
                type="email"
                id="personal_email"
                name="personal_email"
                value={formData.personal_email}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="office_email" className="block mb-2 text-sm font-bold text-gray-700">Office Email:</label>
              <input
                type="email"
                id="office_email"
                name="office_email"
                value={formData.office_email}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="designation" className="block mb-2 text-sm font-bold text-gray-700">Designation:</label>
              <input
                type="text"
                id="designation"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="official_address" className="block mb-2 text-sm font-bold text-gray-700">Company Name:</label>
              <input
                type="text"
                id="official_address"
                name="official_address"
                value={formData.official_address}
                onChange={handleChange}
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>

          <div className="flex justify-end p-4 space-x-8">
            <button
              type="button"
              className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlumniEditForm;